import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const LoginRedirect = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  return (
    <div className="text-center pt-6 border-t border-border">
      <p className="text-sm text-muted-foreground mb-4">
        Haben Sie bereits ein Konto?
      </p>
      <Button
        variant="outline"
        size="default"
        onClick={handleLoginRedirect}
        iconName="LogIn"
        iconPosition="left"
        iconSize={16}
        fullWidth
      >
        Jetzt anmelden
      </Button>
    </div>
  );
};

export default LoginRedirect;